
<ng-container>
    <default-layout></default-layout>
</ng-container>
